export default "__VITE_ASSET__CXTcj2wV__"